import type { AllocabJwtClaims } from '../lib/jwt';
import type { AccountConfig } from '../types/extranet-api.types';

/**
 * Configuration de compte par défaut (libellés, seuils KPI, politique de mot de
 * passe). La route `/v1/extranet/account/config` n'existe pas dans le contrat
 * v1.8.4 (cf. `FEATURES.accountConfigRoute`) : c'est cette valeur qui alimente
 * l'UI, dérivée des claims du JWT pour le nom du compte.
 */
export const defaultAccountConfig = (claims: AllocabJwtClaims): AccountConfig => ({
  accountId: claims.accountKey,
  name: claims.accountCategory ? `Compte ${claims.accountCategory}` : claims.accountKey,
  logoUrl: null,
  labels: {
    account: 'Compte',
    entity: 'Entité',
    contract: 'Contrat',
    site: 'Établissement',
    agent: 'Agent',
    ride: 'Course',
    externalRef: 'Référence externe',
  },
  incidentCategories: [],
  kpiThresholds: {
    coverage: { success: 98, warning: 95 },
    punctuality: { success: 95, warning: 90 },
    incident: { success: 2, warning: 5 },
    security: { success: 0.5, warning: 1 },
    service: { success: 99, warning: 97 },
    late_cancellation: { success: 2, warning: 5 },
    no_show: { success: 1, warning: 3 },
  },
  vatRate: 20,
  passwordPolicy: {
    minLength: 8,
    requireUppercase: true,
    requireDigit: true,
    requireSpecial: false,
    maxFailedAttempts: 5,
  },
});
